<template>
  <div class="connection-pages">
    <v-form ref="form" @submit.prevent="submit">
      <v-row>
        <v-alert
          v-if="errorMessage !== ''"
          type="error"
        >{{ $t(errorMessage) }}</v-alert>
      </v-row>
      <v-row>
        <v-text-field
          v-model="form.email"
          :autofocus=true
          color="#0f3057"
          label="Adresse courriel"
          loader-height="10"
          required
        ></v-text-field>
      </v-row>
      <v-row>
        <v-text-field
          v-model="form.password"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show ? 'text' : 'password'"
          color="#0f3057"
          label="Mot de passe"
          counter
          @click:append="show = !show"
          required
        ></v-text-field>
      </v-row>
      <v-row>
       <v-btn class="mr-4" type="submit"  :tile=true >
            connexion
          </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<style lang="scss">
.v-form {
  background-color: white;
  width: 30%;
  padding: 50px;
  max-width: 500px;
}
.v-label {
  font-size: 20px !important;
}
.connection-pages {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url("../assets/bg.jpg");
  background-size: cover;
}

@media only screen and (max-width: 1100px) {
  .v-form {
    width: 80%;
  }
}
</style>

<script>
import firebase from "../firebaseConfig";
export default {
  data() {
    const connctionForm = Object.freeze({
        username: "",
        password: ""
      });


    return {
      show: false,
      form: Object.assign({}, connctionForm),
       errorMessage: '',
    }
  },
  methods: {
    submit() {
      this.errorMessage = ''
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email.trim().toLowerCase(), this.form.password)
        .then(data => {
          this.$router.replace({ name: "Scheduler" });

        })
        .catch(err => {
          this.errorMessage = err.code;
        });
    }
  }
};
</script>
